
class QuickViewProductTile extends HTMLElement {
  constructor() {
    super();
    this.quickviewTrigger = this.querySelector('.cta__quickview-trigger');
    this.url = this.quickviewTrigger.dataset.url;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.waitForSwiper(() => {
      this.initSwiper();
    });

    this.quickviewTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.quickviewTrigger.classList.add('loading');
      this.loadModal()
    })
  }

  waitForSwiper(callback) {
    const check = () => {
      if (window.Swiper) {
        callback();
      } else {
        requestAnimationFrame(check);
      }
    };
    check();
  }

  initSwiper() {
    const slider = this.querySelector('.quickview-product-tile__image-slider');
    if (!slider || slider.classList.contains('swiper-initialized')) return;

    new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      pagination: false,
      breakpoints: {
        769: {
          pagination: false,
        },
      },
    });
  }

  loadModal() {
    fetch(`${this.url}?view=gh-quickview`)
      .then(res => res.text())
      .then(data => {
        var div = document.createElement("div");
        div.innerHTML = data;
        var productContent = div.querySelector("quickview-product-modal");
        productContent.classList.add('open');

        var modal = document.querySelector('#quickview-product-modal');
        modal.insertAdjacentElement("afterbegin", productContent);

        // dispatch the custom event for shipping time
        const quickViewInitEvent = new CustomEvent('GH_QUICKVIEW_INIT');
        document.dispatchEvent(quickViewInitEvent);
        
        modal.classList.add("open");
        this.quickviewTrigger.classList.remove('loading');
      })
      .catch(err => {
        console.log(err)
      })
  }
}

customElements.define('quick-view-product-tile', QuickViewProductTile);



class ProductQuickViewModal extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.productJson = {};
    this.inputs = this.querySelectorAll('input.option-set__input');
    this.variantInput = this.querySelector('input[name="id"]');
    this.variantId = this.variantInput.value;
    this.mediaId = null;
    this.mediaName = null;
    this.price = this.querySelector('.product-price__regular');
    this.priceCompare = this.querySelector('.product-price__compare');
    this.currency = this.dataset.currency;
    this.closeModal = this.querySelectorAll('[data-quickview-close]');
    this.form = this.querySelector('form');
    this.atc = this.form.querySelector('.content__product-atc');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.fetchProductJson();
    this.waitForSwiper(() => {
      this.initSwiper();
    });

    // close modal
    this.closeModal.forEach(close => {
      close.addEventListener('click', (e) => {
        e.preventDefault();
        this.remove();
      })
    })

    // form handler
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.atc.classList.add('loading');
      this.handleFormSubmit();
    })
  }

  waitForSwiper(callback) {
    const check = () => {
      if (window.Swiper) {
        callback();
      } else {
        requestAnimationFrame(check);
      }
    };
    check();
  }

  initSwiper() {
    const slider = this.querySelector('.content__image-gallery');
    if (!slider || slider.classList.contains('swiper-initialized')) return;

    this.swiper = new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      }
    });
  }

  initProductForm() {
    this.inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        e.preventDefault();
        this.updateProductForm();
      })
    })
  }

  fetchProductJson() {
    fetch(`${this.dataset.productUrl}.js`)
      .then(res => res.json())
      .then(data => {
        this.productJson = data;
        this.initProductForm();
      })
      .catch(err => {
        console.log(err)
      })
  }

  updateProductForm() {
    const checkedInput = this.querySelectorAll('input.option-set__input:checked');
    const selectedVariantName = Array.from(checkedInput).map(input => input.value).join(" / ");
    const variant = this.productJson.variants.find(v => v.title === selectedVariantName);
    const regularPrice = variant.price;
    const comparePrice = variant.compare_at_price;

    // update variant
    this.variantInput.value = variant.id;

    // update price
    this.price.innerHTML = `${this.currency}${(regularPrice / 100).toFixed(2)}`
    if (comparePrice) {
      this.priceCompare.innerHTML = `${this.currency}${(comparePrice / 100).toFixed(2)}`
    } else {
      this.priceCompare.innerHTML = '';
    }

    // update media
    this.mediaId = variant.featured_image.id;
    this.mediaName = variant.featured_image.src.split('/').pop().split('?')[0];
    this.updateMedia();

    // update atc
    if (variant.available) {
      this.atc.disabled = false;
    } else {
      this.atc.disabled = true;
    }
  }

  updateMedia() {
    this.swiper.slides.forEach((slide, index) => {
      const imgUrl = slide.querySelector('img').getAttribute('src');
      const imgName = imgUrl.split('/').pop().split('?')[0];
      if (imgName === this.mediaName) {
        this.swiper.slideTo(index);
      }
    });
  }

  handleFormSubmit(e) {
    const formData = new FormData(this.form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      console.log('Added to cart:', data);
      this.loadAjaxCart();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  }

  loadAjaxCart() {
    fetch("/cart?view=ajax", {
      method: "GET",
      headers: {
        "Content-Type": "application/Html",
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((cartData) => {
      var update_cart_content = document.querySelector(".cart-item__wrapper");
      update_cart_content.innerHTML = cartData;
      var header_cart_quantitys = document.querySelectorAll("[data-cart-item-count]");
      var cart_item_count = update_cart_content.querySelector(".cart-item__extra_info").dataset.item_count;
      var cart_total_price = update_cart_content.querySelector(".cart-item__extra_info").dataset.total_price;
      document.querySelector(".cart_item-count").innerHTML = cart_item_count;
      document.querySelector(".cart_item-total-price").innerHTML = cart_total_price;
      header_cart_quantitys.forEach(function (header_cart_quantity) {
        header_cart_quantity.innerHTML = cart_item_count.split(" ")[0];
        header_cart_quantity.dataset.cartItemCount = cart_item_count.split(" ")[0];
      });

      this.atc.classList.remove('loading');
      this.remove();
      document.querySelector('a[title="Open cart"]').click();
      document.querySelector(".cart_checkout-button").classList.remove("d-none");
    })
    .catch((error) => {
      console.log("Error:", error);
    });
  }
}

customElements.define('quickview-product-modal', ProductQuickViewModal);
